import React, { AnchorHTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';
import { useNavigation, NavigateOptions } from 'context/NavigationContext';

// NavigationLink is a wrapper: the content inside it (a Blade MenuItem, Button,
// logo, ...) does its own styling. The anchor itself must therefore be visually
// silent. Owning these two rules here — like ProfileCard does — means the link
// looks the same everywhere, including inside Blade overlays (Menu, Dropdown),
// which render outside the app root where the app-level CSS reset can't reach.
const PlainAnchor = styled.a`
  text-decoration: none;
  color: inherit;
`;

interface NavigationLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: ReactNode;
  external?: boolean;
  replace?: boolean;
}

export const NavigationLink = ({
  href,
  children,
  external,
  replace,
  onClick,
  ...rest
}: NavigationLinkProps) => {
  const { navigate } = useNavigation();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Allow default browser behavior for ctrl/cmd+click or middle mouse click
    if (e.ctrlKey || e.metaKey || e.button === 1) {
      if (onClick) onClick(e);
      return;
    }

    e.preventDefault();

    if (onClick) {
      onClick(e);
    }

    const options: NavigateOptions = {
      external,
      replace,
    };

    navigate(href, options);
  };

  return (
    <PlainAnchor href={href} onClick={handleClick} {...rest}>
      {children}
    </PlainAnchor>
  );
};

export default NavigationLink;
